<template>
  <div class="container">
    <TopPanel>我的财币</TopPanel>
    <div class="content">
      <div class="remark">账户余额（1人民币=1财币）</div>
      <div class="balance">
        <label>{{ balance.balance }}</label>
        <a class="charge" @click="recharge">充值</a>
      </div>
      <table class="table">
        <thead>
          <th>消费总额</th>
          <th>充值总额</th>
          <th>提现总额</th>
        </thead>
        <tbody>
          <tr>
            <td>{{ statics.expensesAmount }}</td>
            <td>{{ statics.rechargeAmount }}</td>
            <td>{{ statics.withdrawAmount }}</td>
          </tr>
        </tbody>
      </table>
      <div class="line-detail">收支明细</div>
      <el-table :data="tableData" style="width: 100%" class="tableIncome">
        <el-table-column label="时间" width="180">
          <template slot-scope="scope">{{
            convertTime(scope.row.time)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="action"
          label="类型"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="strAmount"
          label="金额"
          width="180"
        ></el-table-column>
        <el-table-column prop="source" label="备注"></el-table-column>
      </el-table>
      <template v-if="tableData">
        <div class="pager">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="tableData.count"
            :page-count="pageCount"
            :page-size="pageSize"
            @current-change="currentChange"
            class="pager"
          ></el-pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getStastics, getIncomeExpenditurePage } from '@/api/vcurrency'
import dayjs from 'dayjs'
import TopPanel from '@/components/Mine/TopPanel'

export default {
  name: 'VCurrency',
  components: { TopPanel },
  data() {
    return {
      statics: { expensesAmount: 0, rechargeAmount: 0, withdrawAmount: 0 },
      testData: [
        {
          time: '2020-10-08 12:56',
          operation: '充值',
          amount: '+2000.00',
          source: '微信'
        },
        {
          time: '2020-10-08 12:56',
          operation: '提现',
          amount: '-1600.00',
          source: '645******023'
        },
        {
          time: '2020-10-08 12:56',
          operation: '充值',
          amount: '+2000.00',
          source: '微信'
        },
        {
          time: '2020-10-08 12:56',
          operation: '支付',
          amount: '-688.00',
          source: '寻龙诀1号'
        }
      ],
      tableData: [],
      pageIndex: 0,
      pageSize: 10,
      total: 0
    }
  },
  computed: {
    pageCount() {
      return parseInt(this.total / this.pageSize) + 1
    },
    balance() {
      return this.$store.state.user.balance
    }
  },
  created() {
    this.loadBalance()
    this.loadStastics()
    this.loadIncomeExpenditure()
  },
  methods: {
    async loadBalance() {
      this.$store.dispatch('user/getBalance')
    },
    async loadStastics() {
      const statics = await getStastics()
      if (statics) {
        this.statics = statics
      }
    },
    async loadIncomeExpenditure() {
      const listData = await getIncomeExpenditurePage(
        this.pageIndex,
        this.pageSize
      )
      if (listData) {
        this.tableData = listData.list
        this.total = listData.total
      }
    },
    convertTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm')
    },
    currentChange(index) {
      this.pageIndex = index - 1
      this.loadIncomeExpenditure()
    },
    recharge() {
      this.$store.dispatch('cashierDesk/openRechargeAction')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 828px;
  height: 1225px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  margin-top: 0px;
}
.content {
  width: 768px;
  display: flex;
  flex-direction: column;
}
.remark {
  height: 15px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 15px;
  letter-spacing: 1px;
  color: #858585;
  margin-left: 21px;
  margin-top: 30px;
}
.balance {
  height: 32px;
  margin-top: 5px;
  display: flex;
}
.balance > label {
  margin-left: 21px;
  height: 100%;
  width: 212px;
}
a.charge {
  width: 90px;
  height: 30px;
  display: inline-block;
  text-decoration: none;
  background-color: #046bcc;
  border-radius: 15px;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
  color: #ffffff;
  cursor: pointer;
}
a.charge:hover,
a.charge:active {
  opacity: 0.5;
}

.stastics {
  height: 40px;
}
.table {
  width: 70%;
  text-align: left;
  margin-top: 33px;
  margin-left: 20px;
}
.table th {
  font-size: 14px;
  color: #858585;
}
.table td {
  font-size: 20px;
  color: #262626;
  height: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.line-detail {
  width: 100%;
  height: 40px;
  margin-top: 31px;
  margin-left: 20px;
  background-color: #f0f0f0;
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  padding-left: 21px;
}
.tableIncome {
  margin-left: 30px;
}
.pager {
  text-align: center;
  margin-top: 50px;
}
</style>
